import request from '@/utils/request';

// 1. 获取企业已购应用列表

export function fetchMyBuyAppsList(params) {
  return request({
    url: '/ajax/enterprises/' + params.eid + '/delivers',
    method: 'get',
    params: params
  });
}
// 2. 获取企业某个已购应用详情数据
export function fetchMyBuyAppsAllInfo(params) {
  return request({
    url: '/ajax/enterprises/' + params.eid + '/delivers/' + params.order_id,
    method: 'get'
  });
}



// WEBPACK FOOTER //
// ./src/api/myBuyApps.js